/**
 * The entity-id PREFIX vocabulary this repo strips before binding an id to a lookup. Ids reach the app in both
 * prefixed and bare forms -- `pr_<id>` for a property, `usr_`/`user_`/`u_` for a user, `ph_` for a photo, and a plain
 * `id_` -- so a participant or home lookup keyed on the bare id must strip whichever prefix arrived.
 *
 * Homed in `const/` because both readers are `utils/` leaves and a utils-to-utils value import is a
 * `QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001` violation with no allowlist -- `const/` is the one shared home the layer floor
 * permits, the same reasoning that homed `const/delimiter-delta.ts` and `const/regex-literal-lexing.ts`.
 *
 * ORDER MATTERS inside the alternation: `user_` precedes `u_` so the longer prefix wins on a `user_` id. Regex
 * alternation is first-match, so reordering these two would leave a stray `ser_` on every `user_`-prefixed id.
 *
 * Case-INSENSITIVE, and `.replace`-only with no `g` flag: exactly one prefix is stripped, from the front. The compiled
 * instance is shared safely -- `/i` carries no `lastIndex`, and a non-global `.replace` reads none.
 */
export const ID_PREFIX_STRIP_REGEX = /^(pr_|ph_|usr_|user_|u_|id_)/i;
